<h2 mat-dialog-title>{{ getDialogTitle() }}</h2>
    <mat-dialog-content>
      <!-- Step 1: Status Selection -->
      @if (currentStep === 'status') {
        <p>This appointment is in the past. Please select an attendance status:</p>
        <div class="status-options">
          <button mat-raised-button color="accent" (click)="selectStatus('SHOW')" [disabled]="isLoading">
            <mat-icon>check_circle</mat-icon> Show
          </button>
          <button mat-raised-button color="warn" (click)="selectStatus('NO_SHOW')" [disabled]="isLoading">
            <mat-icon>cancel</mat-icon> No-Show
          </button>
          <button mat-raised-button color="warn" (click)="selectStatus('CANCEL')" [disabled]="isLoading">
            <mat-icon>block</mat-icon> Cancel
          </button>
          @if(showReschedule) {
            <button mat-raised-button color="primary" (click)="selectStatus('RESCHEDULED')" [disabled]="isLoading">
              <mat-icon>event_repeat</mat-icon> Reschedule
            </button>
          }
        </div>
      }

      <!-- Step 2: Outcome Selection (for SHOW status) -->
      @if (currentStep === 'outcome') {
        <div class="outcome-section">
          <p class="status-confirmation">
            <mat-icon color="accent">check_circle</mat-icon>
            Status set to: <strong>Show</strong>
          </p>
          
          @if (isLoadingOutcomes) {
            <div class="loading-container">
              <mat-spinner diameter="30"></mat-spinner>
              <span>Loading outcomes...</span>
            </div>
          } @else if (activityOutcomes.length > 0) {
            <p>Please select an outcome for this appointment:</p>
            <mat-selection-list #outcomeList [multiple]="false">
              @for (outcome of activityOutcomes; track outcome.outcome_id) {
                <mat-list-option 
                  [value]="outcome.outcome_id" 
                  (click)="selectOutcome(outcome.outcome_id)"
                  [selected]="selectedOutcome === outcome.outcome_id">
                  <div class="outcome-item">
                    <span class="outcome-name">{{ outcome?.outcome?.name }}</span>
                    @if (outcome.description) {
                      <span class="outcome-description">{{ outcome?.outcome?.description }}</span>
                    }
                  </div>
                </mat-list-option>
              }
            </mat-selection-list>
            
            @if (isOutcomeRequired && !selectedOutcome) {
              <div class="requirement-notice">
                <mat-icon color="warn">warning</mat-icon>
                <span>An outcome selection is required for this appointment type.</span>
              </div>
            }
          } @else {
            @if(roleUser == 'ADMIN'){
              <div class="no-outcomes">
                <mat-icon>info_outline</mat-icon>
                <span>No outcomes are configured for this activity type.</span>
                <button mat-raised-button color="primary" (click)="goToOutcomeSettings()" type="button">
                  <mat-icon>add</mat-icon>
                  Create Outcome
                </button>
              </div>
              }@else {
                <div class="no-outcomes">
                  <mat-icon>info_outline</mat-icon>
                  <span>No outcomes are configured for this activity type.</span>
                  <span>Please contact an admin.</span>
                </div>
              }
          }
        </div>
      }

      <!-- Loading state -->
      @if (isLoading && currentStep === 'status') {
        <div class="loading-container">
          <mat-spinner diameter="30"></mat-spinner>
          <span>Processing...</span>
        </div>
      }
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      @if (currentStep === 'status') {
        <button mat-button mat-dialog-close [disabled]="isLoading">Cancel</button>
      } @else if (currentStep === 'outcome') {
        <button mat-button (click)="goBackToStatus()" [disabled]="isLoading">Back</button>
        <button mat-button mat-dialog-close [disabled]="isLoading">Cancel</button>
        <button 
          mat-raised-button 
          color="primary" 
          (click)="confirmWithOutcome()" 
          [disabled]="isLoading || (isOutcomeRequired && !selectedOutcome)">
          @if (isLoading) {
            <mat-spinner diameter="16"></mat-spinner>
          } @else {
            Confirm
          }
        </button>
      }
    </mat-dialog-actions>